import base from '@/api/base'

export default {
  getAvailableRights() {
    return base.get('/me/backend/rights')
  },
}
